import moment from "moment";
import { createTheme } from "@mui/material/styles";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
export const tableTheme = ({ hideToolbar = false }) => {
  const settings = secureLocalStorage.getItem("systemSettings");
  const settingsInfo = JSON.parse(settings);
  const mainBackground = settingsInfo?.mainBackground;

  return createTheme({
    components: {
      MuiTableContainer: {
        styleOverrides: {
          root: {
            border: "2px solid #ddd",
            borderRadius: "50px!important",
            overflow: "hidden",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          },
        },
      },
      MuiToolbar: {
        styleOverrides: hideToolbar && {
          root: {
            display: "none",
          },
        },
      },
      MuiTable: {
        styleOverrides: {
          root: {
            borderCollapse: "separate",
            width: "100%",
            "& th, & td": {
              borderBottom: "2px solid #ddd",
              borderRight: "102",
              BorderLeft: "none",
            },
            "& tr:last-child th, & tr:last-child td": {
              borderBottom: "none",
              borderRight: "none",
              BorderLeft: "none",
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            // paddingLeft: "0px !important",
            background: `${mainBackground} !important`,
            color: "gray",
            fontWeight: "bold!important",

            // whiteSpace: "nowrap",
            // color: "gray",
            // fontWeight:"bold!important",
            // "&:not(:last-child)": {
            //     borderRight: [[1, "solid", "#c0c0c0"]],
            // },
          },
        },
      },
      MuiTableSortLabel: {
        styleOverrides: {
          root: {
            // alignItems: "flex-start",
            // background: "white",
            color: "white",
          },
          active: {
            // background: "white",
            // color: "white",
          },
        },
      },
      MuiTableFooter: {
        styleOverrides: {
          root: {
            background: "white",
          },
        },
      },
    },
  });
};


let isRefreshing = false;
let refreshSubscribers = [];

function onRefreshed(token) {
  refreshSubscribers.forEach((callback) => callback(token));
  refreshSubscribers = [];
}

function subscribeTokenRefresh(callback) {
  refreshSubscribers.push(callback);
}

// Helper to clear session and redirect to login
const handleSessionExpired = (reason = "expired") => {
  localStorage.clear();
  secureLocalStorage.clear();
  // Prevent multiple redirects
  if (!window.location.pathname.includes("/auth")) {
    window.location.href = `/auth/login?${reason}=true`;
  }
};

export const errorInterceptor = async (error) => {
  const originalRequest = error?.config || error?.response?.config;
  const refreshUrl = "/api/user/refresh/token/";
  const refreshToken = secureLocalStorage.getItem("refresh-token");

  // Handle network errors (no response from server)
  if (!error?.response) {
    console.error("Network error or no response:", error?.message);
    return Promise.reject(error);
  }

  const status = error?.response?.status;
  const is401 = status === 401;
  const is403 = status === 403;
  const isNotRefreshCall = !originalRequest?.url?.includes("/refresh/token");

  // If this is a retry that already failed, clear session and redirect
  if (originalRequest?._retry) {
    handleSessionExpired("expired");
    return Promise.reject(error);
  }

  // Handle 403 - No token provided or forbidden
  if (is403) {
    handleSessionExpired("forbidden");
    return Promise.reject(error);
  }

  if (is401 && isNotRefreshCall) {
  // If we have a refresh token, try to refresh
  if (refreshToken) {
    originalRequest._retry = true;

    if (!isRefreshing) {
      isRefreshing = true;
      const baseAxios = axios.create({
        baseURL: process.env.REACT_APP_BACKEND_URL,
      });

      try {
        const response = await baseAxios.post(refreshUrl, { refreshToken });
        const newAccessToken = response?.data?.accessToken;

        if (newAccessToken) {
          secureLocalStorage.setItem("token", newAccessToken);
          localStorage.setItem("lastTime", new Date().toUTCString());
          isRefreshing = false;
          onRefreshed(newAccessToken);

          originalRequest.headers["access-token"] = newAccessToken;
          return axios(originalRequest);
        } else {
          throw new Error("No access token returned.");
        }
      } catch (refreshError) {
        isRefreshing = false;
        refreshSubscribers = [];
        handleSessionExpired("refresh_failed");
        return Promise.reject(refreshError);
      }
    }

      // If already refreshing, queue this request
      return new Promise((resolve, reject) => {
        subscribeTokenRefresh((newToken) => {
          if (newToken) {
            originalRequest.headers["access-token"] = newToken;
            resolve(axios(originalRequest));
          } else {
            reject(error);
          }
        });
      });
    } else {
      // No refresh token available, session is expired
      handleSessionExpired("expired");
      return Promise.reject(error);
    }
  }

  return Promise.reject(error);
};

export const inArray = (haystack, needle) => {
  if (!haystack) {
    return false;
  }

  return haystack.filter((v) => v === needle).length > 0;
};
export const commonError = "Network error.";

export function validatePassword(password) {
  if (password.length < 8) {
    return "Error: Password must be at least 8 characters";
  } else if (password.search(/[a-z]/) < 0) {
    return "Error: Password must contain at least one lowercase letter";
  } else if (password.search(/[A-Z]/) < 0) {
    return "Error: Password must contain at least one uppercase letter";
  } else if (password.search(/[0-9]/) < 0) {
    return "Error: Password must contain at least one number";
  } else {
    return "Success!";
  }
}

export const categoryValues = [
  { label: "Developer", value: "Developer" },
  { label: "DevOps", value: "DevOps" },
  { label: "Security", value: "Security" },
  { label: "Network", value: "Network" },
  { label: "Database", value: "Database" },
  { label: "Software architect", value: "Architect" },
  { label: "Project Manager", value: "Project Manager" },
  { label: "Lead Project Manager", value: "Lead Project Manager" },
  { label: "Business Analysts", value: "Analyst" },
  { label: "Tester", value: "Tester" },
  { label: "Finance & Administration", value: "Finance" },
  { label: "Human resource", value: "Hr" },
  { label: "Management", value: "Management" },
  { label: "CTO", value: "CTO" },
  { label: "CFO", value: "CFO" },
  { label: "CEO", value: "CEO" },
  { label: "COO", value: "COO" },
  { label: "CDO", value: "CDO" },
  { label: "DDG", value: "DDG" },
  { label: "DG", value: "DG" },
  { label: "HOD", value: "HOD" },
  { label: "Head of Division", value: "head of division" },
  { label: "Head of Partnership & Business Development", value: "HPD" },
  { label: "Executive Assistant", value: "executive_assistant" },
  { label: "TA&RC", value: "TA&RC" },
  { label: "Recovery Officer", value: "Recovery Officer" },
];

export const currencyValues = [
  { label: "USD", value: "usd" },
  { label: "RWF", value: "rwf" },
  { label: "Euro", value: "euro" },
];

export const getFileMime = (name) => {
  let lowerCase = name?.split(".")?.pop()?.toLowerCase();
  return isImageExt(lowerCase)
    ? `image/${lowerCase}`
    : inArray(["pdf"], lowerCase)
      ? "application/pdf"
      : inArray(["mov", "mp4", "mkv", "wmv", "avi", "webm"], lowerCase)
        ? `video/${lowerCase}`
        : "application/octet-stream";
};

export const getError = (resp) => {
  return resp?.data?.response?.data?.message ?? commonError;
};
export const getSuccessMessage = (resp) => {
  return resp?.data?.message ?? "Success !";
};

export const isImageExt = (name) => {
  return inArray(["jpg", "png", "webp", "jpeg", "gif"], name);
};

export const allowedTypes =
  ".pdf,image/*,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const getDuration = (end, date = null) => {
  const excludeWeekends = (startDate, endDate) => {
    let currentDate = moment(startDate);
    let daysCount = 0;

    while (currentDate.isBefore(endDate)) {
      if (currentDate.day() !== 0 && currentDate.day() !== 6) {
        daysCount++;
      }
      currentDate.add(1, "days");
    }

    return daysCount;
  };

  if (end) {
    const startDate = moment(date ?? moment());
    const endDate = moment(end);

    if (endDate.diff(startDate) > 0) {
      let years = endDate.diff(startDate, "years");
      if (years > 0) {
        return `${years}yrs`;
      }

      let months = endDate.diff(startDate, "months");
      if (months > 0) {
        return `${months}mo`;
      }

      let days = excludeWeekends(startDate, endDate); // Adjust days by excluding weekends
      if (days > 0) {
        return `${days}dys`;
      }

      let hours = endDate.diff(startDate, "hours");
      if (hours > 0) {
        return `${hours}hrs`;
      }

      let minutes = endDate.diff(startDate, "minutes");
      if (minutes < 0) {
        return `-${getDuration(new Date(), end)}`;
      }

      return `${minutes}min`;
    }

    return 0;
  } else {
    return "Un-estimated";
  }
};

export const requestInterceptor = (request) => {
  const token = secureLocalStorage.getItem("token");
  const refreshToken = secureLocalStorage.getItem("refresh-token");
  const lastTime = localStorage.getItem("lastTime");

  // console.log("Request Interceptor:", {
  //   token,
  //   refreshToken,
  //   lastTime,
  // });

  if (token) request.headers["access-token"] = token;
  if (refreshToken) request.headers["refresh-token"] = refreshToken;
  if (lastTime) request.headers["last-time"] = lastTime;

  return request;
};

export const responseInterceptor = (response) => {
  if (response.headers["new-access-token"]) {
    secureLocalStorage.setItem("token", response.headers["new-access-token"]);
  }
  localStorage.setItem("lastTime", new Date().toUTCString());
  return response;
};
